import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_INTERVAL_SUCCESS,
  FETCH_INTERVAL_SUCCESS,
  GET_INTERVAL_SUCCESS,
  SAVE_INTERVAL_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import {getUser} from "./Auth";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_INTERVAL_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_INTERVAL_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_INTERVAL_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_INTERVAL_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {interval} = store.getState();
      const {query} = interval;
      const response = await axios.get(`/interval?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {interval} = store.getState();
      const {query} = interval;
      const response = await axios.get(`/interval/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect= true, module, subMaster= false, superMaster=false) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/interval`, payload);
      if(response && response.data && response.data.code === 202){
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }
      if (!redirect) {
        if(subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if (superMaster) {
            dispatch(fetchSuperMasterFilter(module));
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push('/interval');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response=await axios.put(`/interval/${id}`, payload);
      if (response && response.data && response.data.code === 202){
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/interval');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/interval/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/interval/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
